import { Input, CitySelect, notify, SelectOption, UploadFile } from '../../utils';
import { FormProvider, useForm } from 'react-hook-form';
import { TextArea } from '../../utils/TextArea';
import {ChangeStep, prevStep} from '../../redux/actions/StepperAction';
import {useEffect, useState} from 'react';
import {companyInfoComplete, getCompanyInfo} from '../../../api/MoadianService';
import { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import {ShowInfo} from "../../utils";
import {useNavigate} from "react-router-dom";

export default function CompanyInfo() {

    const [isSubmitted, setIsSubmitted] = useState(false)
    const tokenInfo = useSelector(state => state.Token)
    const [companyInfo, setCompanyInfo] = useState('')
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const methods = useForm();

    const formData = new FormData();

    useEffect(() => {

        getCompanyInfo(tokenInfo.transactionId).then(response => {

            if(response?.data?.companyInfo) {
                methods.reset(response.data.companyInfo);
                methods.setValue("province", {
                    label: response?.data?.companyInfo?.province ?? "",
                    value: response?.data?.companyInfo?.province ?? ""
                });
                methods.setValue("city", {
                    label: response?.data?.companyInfo?.city ?? "",
                    value: response?.data?.companyInfo?.city ?? ""
                });
                methods.setValue("companyType", {
                    label: response.data.companyInfo?.companyType == "Governmental" ? "دولتی" : "غیر دولتی",
                    value: response.data.companyInfo?.companyType ?? ""
                })
                setCompanyInfo(response.data.companyInfo);
            }

        }).catch(error => {
            notify(error?.response?.data?.message);
        })

    }, [])

    const onSubmit = methods.handleSubmit(data => {
        setIsSubmitted(true)

        const dataToSend = {
            ...data,
            province:data.province.value,
            city:data.city.value,
            companyType:data.companyType.value
        }

        Object.keys(dataToSend).forEach((key) => {

            formData.append(key, dataToSend[key])

        });
        //
        // for (var pair of formData.entries()) {
        //     console.log(pair[0]+ ', ' + pair[1]);
        // }

        companyInfoComplete(tokenInfo.transactionId, formData).then(response => {
            setIsSubmitted(false)
            navigate('/company/list')
        }).catch(
            error => {
                setIsSubmitted(false)
                notify(error.response.data.message)
            }
        )

    })

    return(
        <div>
            <Toaster />
            <ShowInfo
                title={'تکمیل اطلاعات شرکت'}
                message={'لطفا اطلاعات مربوط به شرکت را با دقت وارد نمایید.'}
            />

            <FormProvider {...methods}>
                <form
                    onSubmit={e => e.preventDefault()}
                    noValidate
                    className="container"
                >

                    <Input
                        lable_text="نام ثبتی سازمان/شرکت/موسسه"
                        type="text"
                        name="companyName"
                        placeholder="نام ثبت شده"
                        validation={{
                            required: {
                                value: true,
                                message: 'نام ثبت شده برای سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                        }}
                    />

                    <Input
                        lable_text="شناسه ملی سازمان/شرکت/موسسه"
                        type="text"
                        name="companyNationalId"
                        placeholder="شناسه ملی ثبت شده"
                        validation={{
                            required: {
                                value: true,
                                message: 'شناسه ملی سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                        }}
                        tooltip_title={'جهت دریافت این شناسه، به پایگاه اطلاع‌رسانی شناسه ملی اشخاص حقوقی کشور به آدرس www.ilenc.ir مراجعه نمایید.'}
                    />

                    <SelectOption
                        lable_text={'نوع سازمان/شرکت/موسسه'}
                        placeholder={'انتخاب نوع سازمان'}
                        optionList={[
                            {value: 'Governmental', label: 'دولتی'},
                            {value: 'Non-Governmental', label: 'غیر دولتی'}
                        ]}
                        name={'companyType'}
                        errorMessage={'نوع سازمان خود را انتخاب کنید'}
                    />

                    <CitySelect control={methods.control} watch={methods.watch}/>

                    <TextArea
                        lable_text="آدرس محل اقامت"
                        type="text"
                        name="address"
                        placeholder="آدرس محل اقامت خود را وارد کنید"
                        validation={{
                            required: {
                                value: true,
                                message: 'آدرس محل اقامت خود را وارد کنید',
                            },
                        }}
                    />

                    <Input
                        lable_text="شماره تلفن"
                        type="text"
                        name="phoneNumber"
                        placeholder="شماره تلفن سازمان"
                        validation={{
                            required: {
                                value: true,
                                message: 'شماره تلفن سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                        }}
                    />

                    <Input
                        lable_text="نام ثبتی سازمان/شرکت/موسسه (انگلیسی)"
                        type="text"
                        name="latinCompanyName"
                        placeholder="نام ثبت شده"
                        validation={{
                            required: {
                                value: true,
                                message: 'نام ثبت شده برای سازمان/شرکت/موسسه خود را وارد کنید',
                            },
                            pattern: {
                                value: /^[A-Za-z\s]+$/,
                                message: 'لطفا فقط حروف انگلیسی وارد کنید',
                            },
                        }}
                    />

                    <UploadFile
                        label_text={'تصویر معرفی نامه '}
                        name={'introductionLetterImage'}
                        validation={{
                            required: {
                                value: true,
                                message: 'تصویر معرفی نامه را وارد کنید',
                            },
                        }}
                        href={"/form-ex/present.pdf"}
                        fileName={'moarfi_name_ex.pdf'}
                    />

                    <UploadFile
                        label_text={'تصویر آخرین تغییرات شرکت (روزنامه رسمی)'}
                        name={'latestOfficialNewspaperImage'}
                        validation={{
                            required: {
                                value: true,
                                message: 'تصویر آخرین روزنامه تغییرات شرکت را وارد کنید',
                            },
                        }}
                    />

                    <UploadFile
                        label_text={'تصویر روی کارت ملی مدیر عامل'}
                        name={'managerNationalCardImage'}
                        validation={{
                            required: {
                                value: true,
                                message: 'تصویر روی کارت ملی مدیر عامل را وارد کنید',
                            },
                        }}
                    />

                    <UploadFile
                        label_text={'تصویر آگهی تاسیس شرکت (روزنامه رسمی)'}
                        name={'establishedNewspaperImage'}
                        validation={{
                            required: {
                                value: true,
                                message: 'تصویر روزنامه تاسیس شرکت را وارد کنید',
                            },
                        }}
                    />

                    <div className='row justify-content-center my-3 mt-5'>

                        <div className='col-12 col-md-5 d-flex justify-content-between'>
                            <button
                                className='btn border text-form-title ms-2'
                                style={{"padding": "1.5% 17%"}}
                                onClick={() => dispatch(prevStep())}
                            >بازگشت</button>

                            <button
                                onClick={onSubmit}
                                className='btn text-form-button me-2'
                                style={{"background" : "#044448", "padding": "1% 17%"}}
                            >ادامه</button>
                        </div>
                    </div>

                </form>
            </FormProvider>
            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}
        </div>

    )
}